function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 21.5V15.8125H14.1875L11.5737 18.4288C12.4755 19.351 13.7101 19.8721 15 19.875C17.0633 19.872 18.9012 18.5703 19.589 16.625H19.6036C19.6967 16.3606 19.7671 16.0888 19.8141 15.8125H21.4488C21.0394 19.0624 18.2756 21.4999 15 21.5H14.9919C13.2684 21.5052 11.6144 20.8205 10.3988 19.5988L8.5 21.5ZM10.1851 14.1875H8.55037C8.95967 10.9388 11.7216 8.50175 14.9959 8.49997H15C16.7238 8.49446 18.3781 9.17913 19.5939 10.4013L21.5 8.49997V14.1875H15.8125L18.4304 11.5713C17.5276 10.648 16.2913 10.1267 15 10.125C12.9367 10.1281 11.0988 11.4297 10.411 13.375H10.3964C10.3026 13.6392 10.2322 13.911 10.1859 14.1875H10.1851Z",
  fill: "white"
});

var SvgSync = function SvgSync(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSync, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sync.223ad43e.svg";
export { ForwardRef as ReactComponent };